import { RiCalendar2Line } from "@remixicon/react";
import { Button } from "@workspace/ui/components/button";
import { Card } from "@workspace/ui/components/card";

interface CalendarEmptyStateProps {
	onShowAllStages: () => void;
	onClearFilters?: () => void;
	hasActiveFilters?: boolean;
}

export function CalendarEmptyState({
	onShowAllStages,
	onClearFilters,
	hasActiveFilters = false,
}: CalendarEmptyStateProps) {
	const title = hasActiveFilters
		? "No Sets Match Your Filters"
		: "No Stages to Display";
	const description = hasActiveFilters
		? "Try clearing filters to see all sets."
		: "Only stages with your saved sets are shown.";

	return (
		<Card className="p-8 text-center">
			<div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
				<RiCalendar2Line className="h-6 w-6 text-muted-foreground" />
			</div>
			<h3 className="mb-1 font-semibold text-xl">{title}</h3>
			<p className="mb-4 text-muted-foreground text-sm">{description}</p>
			<div className="mt-4 flex justify-center gap-2">
				{!hasActiveFilters && (
					<Button variant="secondary" size="sm" onClick={onShowAllStages}>
						Show All Stages
					</Button>
				)}
				{hasActiveFilters && onClearFilters && (
					<Button variant="secondary" size="sm" onClick={onClearFilters}>
						Clear Filters
					</Button>
				)}
			</div>
		</Card>
	);
}
